import * as dbConstants from '../dao/dbConstants';

export const SERVER_URL = import.meta.env.REACT_APP_API_URL || ''
export const METHOD_GET = 'get'
export const METHOD_POST = 'post'
export const METHOD_PUT = 'put'
export const METHOD_DELETE = 'delete'

export const entityAPIRoutes = {
  [dbConstants.ENTITY_NAME_ANSWER]: 'answers',
  [dbConstants.ENTITY_NAME_ARTICLE]: 'articles',
  [dbConstants.ENTITY_NAME_ARTICLE_TYPE]: 'articletypes',
  [dbConstants.ENTITY_NAME_ASSET]: 'assets',
  [dbConstants.ENTITY_NAME_BRAND_VOICE]: 'brandvoices',
  [dbConstants.ENTITY_NAME_CAMPAIGN]: 'campaigns',
  [dbConstants.ENTITY_NAME_COMPANY]: 'companies',
  [dbConstants.ENTITY_NAME_COMPANY_TYPE]: 'companytypes',
  [dbConstants.ENTITY_NAME_COMPANY_SUB_TYPE]: 'companysubtypes',
  [dbConstants.ENTITY_NAME_CONTENT]: 'contents',
  [dbConstants.ENTITY_NAME_FIRM]: 'firms',
  [dbConstants.ENTITY_NAME_GUIDELINES]: 'guidelines',
  [dbConstants.ENTITY_NAME_KNOWLEDGE_BASE]: 'knowledgebases',
  [dbConstants.ENTITY_NAME_PERSONA]: 'personas',
  [dbConstants.ENTITY_NAME_PRODUCT]: 'products',
  [dbConstants.ENTITY_NAME_PRODUCT_TYPE]: 'producttypes',
  [dbConstants.ENTITY_NAME_PUBLISH]: 'publishes',
  [dbConstants.ENTITY_NAME_SOURCE_CONTENT]: 'sourcecontents',
  [dbConstants.ENTITY_NAME_TOPIC]: 'topics',
  [dbConstants.ENTITY_NAME_USER]: 'users',
  [dbConstants.ENTITY_NAME_WRITING_STYLE]: 'writingstyles',
  [dbConstants.ENTITY_NAME_WRITING_STYLE_TYPE]: 'writingstyletypes',
  [dbConstants.ENTITY_NAME_ROLE]: 'roles',
  [dbConstants.ENTITY_NAME_PERMISSION]: 'permissions',
  [dbConstants.ENTITY_NAME_CONTENT_TYPE]: 'contenttypes',
  [dbConstants.ENTITY_NAME_LINK]: 'assets/links',
  [dbConstants.ENTITY_NAME_TESTIMONIAL]: 'assets/testimonials',

  [dbConstants.ENTITY_NAME_BACK_OFFICE_FIRM]: 'bo/firms',
  [dbConstants.ENTITY_NAME_BACK_OFFICE_FIRM_STATUS]: 'bo/firmstatuses',
  [dbConstants.ENTITY_NAME_BACK_OFFICE_BILLING_METRICS]: 'bo/billing',
  [dbConstants.ENTITY_NAME_BACK_OFFICE_BILLING_METRICS_FIRM_NAME]: 'bo/allfirmsnames',
  [dbConstants.ENTITY_NAME_BACK_OFFICE_BILLING_METRICS_USER_NAME]: 'bo/users',
  [dbConstants.ENTITY_NAME_BACK_OFFICE_BILLING_METRICS_SCREEN]: 'bo/billing/allscreens',
  [dbConstants.ENTITY_NAME_BACK_OFFICE_BILLING_METRICS_OPERATION]: 'bo/billing/alloperations',
  [dbConstants.ENTITY_NAME_BACK_OFFICE_PROMPT_TEMPLATE]: 'bo/prompts',
  [dbConstants.ENTITY_NAME_BACK_OFFICE_INSTRUCTION_BLOCK]: 'bo/instruction-blocks',
  [dbConstants.ENTITY_NAME_BACK_OFFICE_SUPPORT_REQUEST]: 'bo/support-requests',
  [dbConstants.ENTITY_NAME_BACK_OFFICE_USER]: 'bo/backofficeusers',
  [dbConstants.ENTITY_NAME_BACK_OFFICE_CONTENT_VALIDATOR]: 'bo/content-validators',
}

export const API_GOOGLE_SEARCH = 'google/search';
export const API_YOUTUBE_SEARCH = 'youtube/search';
export const API_YOUTUBE_SUMMARY = 'youtube/summary';
export const API_YOUTUBE_TRANSCRIPT = 'youtube/transcript';
export const API_WEB_SUMMARY = 'web/summary';
export const API_WEB_TITLE = 'web/title';
export const SCAN_BASE = '/api/ui/scans';
